
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 501 570"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M312.8 56.5c-2.6.7-6.1 2.1-7.8 3.2-1.7 1.1-45.3 43.9-96.9 95.1-72 71.4-94.5 94.3-96.3 97.9-2 4.1-2.3 6.3-2.3 15.3s.3 11.2 2.3 15.3c1.8 3.6 24.5 26.7 96.5 98.2 105 104.3 98.9 99 112.7 98.9 5.4 0 8.8-.6 12.1-2.1 16.4-7.4 23.2-26.6 15-42.2-1-1.8-38.9-40.4-84.2-85.7l-82.4-82.5 82.4-82.2c90.8-90.6 87.4-86.6 87.5-99.1.1-7.8-1.6-13.5-5.7-18.8-4.2-5.5-9.8-9.3-16.8-11.2-6.5-1.9-9.7-1.9-16.1-.1z","fill":"#CF0209"}})])
          )
        }
      }
    